<div class="quick-settings-wrapper relative flex items-center">
    <!-- Trigger -->
    <button
        type="button"
        (click)="toggleQuickSettingsDropdown()"
        class="group flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-white transition-all duration-300 hover:scale-[1.05] hover:shadow-sm active:scale-95 dark:border-stone-700 dark:bg-black">
        <i
            class="pi pi-cog text-card-text text-[1.2rem] transition-transform duration-800 group-hover:rotate-[180deg]">
        </i>
    </button>

    <!-- Dropdown -->
    @if (isQuickSettingsDropdownVisible()) {
        <div
            class="animate-in fade-in zoom-in-95 absolute top-12 -right-14 z-50 w-[290px] origin-top-right rounded-2xl border border-gray-200/70 bg-white/95 p-3 shadow-2xl backdrop-blur-xl duration-200 md:-right-16 dark:border-stone-700 dark:bg-neutral-900/95">
            <!-- Header -->
            <div class="mb-3 px-1">
                <h3 class="text-card-title text-sm font-semibold">
                    Quick Settings
                </h3>

                <p class="secondary-text-2 text-xs">
                    Personalize your workspace
                </p>
            </div>

            <!-- Easy Mode -->
            <!-- <button
                (click)="goToEasyMode()"
                class="flex w-full cursor-pointer items-center gap-3 rounded-2xl px-3 py-3 transition-all duration-300 hover:bg-gray-100/70 dark:hover:bg-white/[0.04]">
                <div
                    class="flex h-10 w-10 items-center justify-center rounded-xl bg-olive-200/70 dark:bg-white/[0.04]">
                    <i
                        class="pi text-xl"
                        [ngClass]="
                            isEasyMode()
                                ? 'pi-desktop text-rose-500'
                                : 'pi-bolt text-primary'
                        ">
                    </i>
                </div>

                <div class="flex flex-1 flex-col text-left">
                    <span class="text-card-title text-sm font-semibold">
                        {{
                            isEasyMode()
                                ? 'Turn Off Easy Mode'
                                : 'Turn On Easy Mode'
                        }}
                    </span>

                    <span class="secondary-text-2 text-xs">
                        {{
                            isEasyMode()
                                ? 'Back to standard dashboard'
                                : 'Simplified dashboard'
                        }}
                    </span>
                </div>
            </button> -->

            <!-- Theme -->
            <div
                class="mt-1 flex items-center justify-between rounded-2xl px-3 py-3 transition-all duration-300 hover:bg-gray-100/70 dark:hover:bg-white/[0.04]">
                <!-- Left -->
                <div class="flex items-center gap-3">
                    <div
                        class="flex h-10 w-10 items-center justify-center rounded-xl bg-olive-200/70 dark:bg-white/[0.04]">
                        <i
                            class="pi text-xl transition-all duration-500 ease-in-out"
                            [ngClass]="
                                themeChecked
                                    ? 'pi-moon text-indigo-400'
                                    : 'pi-sun text-orange-400'
                            ">
                        </i>
                    </div>

                    <div class="flex flex-col">
                        <span class="text-card-title text-sm font-semibold">
                            Appearance
                        </span>

                        <span class="secondary-text-2 text-xs">
                            {{ themeChecked ? 'Dark mode' : 'Light mode' }}
                        </span>
                    </div>
                </div>

                <!-- Smooth Toggle -->
                <button
                    type="button"
                    (click)="toggleTheme()"
                    class="relative h-7 w-14 cursor-pointer rounded-full transition-all duration-500 ease-in-out"
                    [ngClass]="
                        themeChecked ? 'bg-indigo-500' : 'bg-orange-400'
                    ">
                    <div
                        class="absolute top-1 flex h-5 w-5 items-center justify-center rounded-full bg-white shadow-sm transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]"
                        [ngClass]="themeChecked ? 'left-8' : 'left-1'">
                        <i
                            class="pi text-[9px] transition-all duration-300"
                            [ngClass]="
                                themeChecked
                                    ? 'pi-moon text-indigo-500'
                                    : 'pi-sun text-orange-400'
                            ">
                        </i>
                    </div>
                </button>
            </div>

            <!-- Divider -->
            <div
                class="my-4 border-t border-dashed border-gray-200 dark:border-stone-800"></div>

            <!-- Language -->
            <div class="px-1">
                <div class="mb-3 flex items-center justify-between">
                    <p
                        class="text-xs font-semibold tracking-wide text-gray-400 uppercase">
                        Language
                    </p>

                    <span
                        class="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-500 dark:bg-white/5">
                        {{ languageService.activeLang() | uppercase }}
                    </span>
                </div>

                <!-- Same Row -->
                <div class="grid grid-cols-2 gap-3">
                    @for (lang of languageService.langs; track lang.code) {
                        <button
                            (click)="languageService.selectLanguage(lang.code)"
                            class="flex cursor-pointer items-center justify-center gap-2 rounded-xl border px-2 py-1 transition-all duration-200"
                            [ngClass]="
                                languageService.activeLang() === lang.code
                                    ? 'border-primary text-primary dark:border-primary dark:bg-primary/10 bg-olive-100'
                                    : 'text-card-text border-gray-200 hover:bg-gray-100 dark:border-stone-700 dark:hover:bg-white/[0.04]'
                            ">
                            <span class="text-lg">
                                {{ lang.flag }}
                            </span>

                            <span class="font-medium">
                                {{ lang.label }}
                            </span>
                        </button>
                    }
                </div>
                @if (!isEasyMode()) {
                    <a
                        href="/dashboard/settings"
                        class="text-card-text hover:text-primary mt-4 flex items-center justify-center gap-2 text-sm font-medium">
                        All Settings
                        <i
                            class="pi pi-external-link"
                            style="font-size: 0.8rem"></i>
                    </a>
                }
            </div>
        </div>
    }
</div>
